import { render, staticRenderFns } from "./AlbumLanding.vue?vue&type=template&id=c4648fcc&scoped=true&"
import script from "./AlbumLanding.vue?vue&type=script&lang=js&"
export * from "./AlbumLanding.vue?vue&type=script&lang=js&"
import style0 from "./AlbumLanding.vue?vue&type=style&index=0&id=c4648fcc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4648fcc",
  null
  
)

export default component.exports